<ng-container [ngSwitch]="df.view">

  <!-- Search history -->
  <ng-container *ngSwitchCase="'history'">
    <div class="page-h"><h2>Search history</h2><p>Your earlier searches. Open one to pick up where you left off.</p></div>
    <div class="card" style="margin-top:18px">
      <div class="tbl-scroll"><table class="tbl" *ngIf="df.history.length; else noHistory">
        <thead><tr><th>Question</th><th>Date</th><th>Found</th><th>Status</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of df.history">
            <td style="font-weight:600;color:var(--ink);white-space:normal">
              <button type="button" class="link open-search" (click)="openSearch(r.query)">{{ r.query }}</button>
            </td>
            <td>{{ r.date }}</td><td>{{ r.n }}</td><td>{{ r.status }}</td>
          </tr>
        </tbody>
      </table></div>
      <ng-template #noHistory><div class="empty">No searches yet.</div></ng-template>
    </div>
  </ng-container>

  <!-- Published packs -->
  <ng-container *ngSwitchCase="'packs'">
    <div class="page-h"><h2>Published packs</h2><p>Confirmed document lists that the Explore workstreams use as their inputs.</p></div>
    <div class="card" style="margin-top:18px">
      <div class="tbl-scroll"><table class="tbl packs-tbl" *ngIf="df.packs.length; else noPacks">
        <thead><tr><th>Pack</th><th>Name</th><th>Documents</th><th>Published</th></tr></thead>
        <tbody><tr *ngFor="let p of df.packs"><td>{{ p.id }}</td><td>{{ p.name }}</td><td>{{ p.n }}</td><td>{{ p.at }}</td></tr></tbody>
      </table></div>
      <ng-template #noPacks><div class="empty">No packs published yet.</div></ng-template>
    </div>
  </ng-container>

  <!-- Process map -->
  <ng-container *ngSwitchCase="'process'">
    <div class="page-h"><h2>Process map</h2><p>The hierarchy the agent uses to expand a question into process codes.</p></div>
    <div class="stack" style="margin-top:18px">
      <div class="card">
        <div class="tbl-scroll"><table class="tbl" *ngIf="l2.length; else noL2">
          <thead><tr><th>L2 code</th><th>Name</th></tr></thead>
          <tbody><tr *ngFor="let x of l2"><td>{{ x.id }}</td><td>{{ x.name }}</td></tr></tbody>
        </table></div>
        <ng-template #noL2><div class="empty">No L2 processes returned by the API.</div></ng-template>
      </div>
      <div class="card">
        <div class="tbl-scroll"><table class="tbl" *ngIf="processMap.length; else noMap">
          <thead><tr><th>Code</th><th>Sub-process</th><th>Description</th></tr></thead>
          <tbody><tr *ngFor="let r of processMap"><td>{{ r.code }}</td><td>{{ r.name }}</td><td>{{ r.description }}</td></tr></tbody>
        </table></div>
        <ng-template #noMap><div class="empty">No process map returned by the API.</div></ng-template>
      </div>
    </div>
  </ng-container>

  <!-- Taxonomy -->
  <ng-container *ngSwitchCase="'taxonomy'">
    <div class="page-h"><h2>Document taxonomy</h2><p>What the agent retrieves as an Explore input, and what Explore produces.</p></div>
    <div class="stack" style="margin-top:18px">
      <div class="card">
        <div class="tbl-scroll"><table class="tbl" *ngIf="taxonomy.rows.length; else noTax">
          <thead><tr><th>Document</th><th>As-Is (ECC)</th><th>To-Be (S/4HANA)</th><th>Role</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of taxonomy.rows">
              <td>{{ r.document }}</td><td>{{ r.asis }}</td><td>{{ r.tobe }}</td>
              <td><span class="pill" [class.tobe]="r.role === 'Input'">{{ r.role }}</span></td>
            </tr>
          </tbody>
        </table></div>
        <ng-template #noTax><div class="empty">No taxonomy returned by the API.</div></ng-template>
      </div>
      <div class="card" *ngIf="taxonomy.acronyms.length">
        <div class="tbl-scroll"><table class="tbl">
          <thead><tr><th>Acronym</th><th>Meaning</th></tr></thead>
          <tbody><tr *ngFor="let r of taxonomy.acronyms"><td>{{ r.term }}</td><td>{{ r.meaning }}</td></tr></tbody>
        </table></div>
      </div>
    </div>
  </ng-container>

  <!-- Feedback log -->
  <ng-container *ngSwitchCase="'log'">
    <div class="page-h"><h2>Relevance feedback log</h2><p>Every correction you make is kept here. This is the training signal for improving retrieval.</p></div>
    <div class="card" style="margin-top:18px">
      <div class="tbl-scroll"><table class="tbl log-tbl" *ngIf="excludedAll.length || df.missing.length; else noLog">
        <thead><tr><th>Kind</th><th>Document</th><th>Detail</th></tr></thead>
        <tbody>
          <tr *ngFor="let d of excludedAll">
            <td>Irrelevant</td>
            <td style="font-weight:600;color:var(--ink);white-space:normal">{{ d.name }}</td>
            <td>{{ df.reasons[d.id] || 'No reason given' }}{{ df.whys[d.id] ? ' — ' + df.whys[d.id] : '' }}</td>
          </tr>
          <tr *ngFor="let m of df.missing">
            <td>Missed</td>
            <td style="font-weight:600;color:var(--ink);white-space:normal">{{ m.title }}
              <div class="hint" *ngIf="m.attachment as attachment">{{ attachment.name }} · Uploaded; not yet searchable</div>
            </td>
            <td>{{ docTypes[m.type].short }} · {{ landscapeLabel(m.land) }} · {{ m.l2 }}{{ m.loc ? ' · ' + m.loc : '' }}</td>
          </tr>
        </tbody>
      </table></div>
      <ng-template #noLog><div class="empty">No feedback yet. Mark documents irrelevant or report missing ones during a search.</div></ng-template>
    </div>
  </ng-container>

  <!-- Help -->
  <ng-container *ngSwitchCase="'help'">
    <div class="page-h"><h2>Help</h2><p>How Digital Core - Smart Design works.</p></div>
    <div class="card pad" style="margin-top:18px;max-width:760px;line-height:1.6">
      <ol style="margin:0;padding-left:18px">
        <li><b>Ask</b> for a process. The agent reads the process, landscape and document types from your question.</li>
        <li><b>Retrieve.</b> It expands the process into L2 and L3 codes and searches SharePoint, Documentum and Signavio. It classifies each file by its template first and its filename second.</li>
        <li><b>Review.</b> Results are grouped by document type. Confirm each one, and use the coverage check to spot gaps.</li>
        <li><b>Feedback.</b> Tell the agent why something is irrelevant, and describe anything it missed.</li>
        <li><b>Publish</b> the confirmed pack for the Explore workstream.</li>
      </ol>
    </div>
  </ng-container>

  <!-- Settings -->
  <ng-container *ngSwitchCase="'settings'">
    <div class="page-h"><h2>Settings</h2><p>Defaults for new searches.</p></div>
    <div class="card pad" style="margin-top:18px;max-width:640px">
      <div class="form">
        <div class="full"><label>Auto-mark as relevant above</label><input class="fld" value="70% confidence" readonly></div>
        <div class="full"><label>Default sources</label><input class="fld" [value]="defaultSources" readonly></div>
      </div>
    </div>
  </ng-container>

</ng-container>
